export default httpClient => ({
    save: async ({ nome, link, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.post('/grupos-apoios', {
            nome,
            link,
        }, { headers })
        return {
            data: response.data,
        }
    },
    update: async ({ id, nome, link, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.patch('/grupos-apoios/' + id, {
            id,
            nome,
            link,
        }, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/grupos-apoios/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/grupos-apoios', { headers });
        return { data: response.data }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/grupos-apoios/' + id, { headers });
        return {
            data: response
        }
    },
});